import { Link } from 'react-router-dom'
import dayjs from 'dayjs'
import { Plus } from 'react-feather'

import { useTimerStore, useLoginStore, useSettingsStore } from 'stores'

import {
  Main,
  Timer,
} from 'components'

import {
  TimerContainer,
  FAB,
} from './homeStyle'

const Home = () => {
  const timers = useTimerStore(state => state.timers)
  const isLoading = useLoginStore(state => state.isLoading)
  const useGridLayout = useSettingsStore(state => state.useGridLayout)
  
  return (
    <Main style={{
      display: timers.length > 0 ? 'block' : 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      {timers.length > 0 ? (
        <TimerContainer data-gridlayout={useGridLayout}>
          {timers.sort((a, b) => dayjs(a.date).diff(b.date)).map(timer => (
            <Timer
              key={timer.id}
              id={timer.id}
              name={timer.name}
              color={timer.color}
              date={dayjs(timer.date)}
              isRepeating={timer.isRepeating}
              repeatFrequency={timer.repeatFrequency}
            />
          ))}
        </TimerContainer>
      ) : (
        isLoading ? (
          <div>Syncing, please wait...</div>
        ) : (
          <div>You don't have any countdowns yet. <Link to="/new">Create one</Link>!</div>
        )
      )}

      <FAB as={Link} to="/new">
        <Plus />
        <span>New</span>
      </FAB>
    </Main>
  )
}

export default Home